const tableColumns = [
  {
    prop: 'name',
    label: 'Name',
    sortable: true,
    width: 200
  },
  {
    prop: 'description',
    label: 'Description',
    sortable: false,
    width: 300
  },
  {
    prop: 'createdOn',
    label: 'Created on',
    sortable: true
  }
];

const tableFilters = [
  {
    label: 'Deleted',
    name: 'deleted',
    search: 'status',
    param: 'deleted'
  }
];

const tableOptions = {
  'default-sort': {
    prop: 'createdOn',
    order: 'descending'
  },
  limit: 10,
  searchParams: {
    default: 'name',
    params: [
      {
        label: 'Name',
        value: 'name'
      },
      {
        label: 'Email',
        value: 'email'
      }
    ]
  }
};

export { tableColumns, tableFilters, tableOptions };
